import React from 'react'
import { Box } from 'pcln-design-system'

const SponsoredAd = ({ adId, gaIndex }) => (
  <Box mx={[2, 2, 2, 2, 0]} data-ga-index={gaIndex}>
    <div id={adId} />
  </Box>
)

export { SponsoredAd }
